<template>
<!-- // Depois voltar para v-select e não vai precisar mais da props filter pois já terá o pesquisar -->
  <v-select
    v-if="showSelect"
    :filter="filter"
    :id="id"
    :content-class="id+'_class'" 
    :value="value"
    @input="(val) => $emit('input', val)"
    no-data-text="Nenhum registro encontrado"
    no-results-text="Nenhum registro encontrado"
    @change="changeSelect"
    @click.native="clickSelect"
    @blur="blurSelect"
    :items="items"
    :clearable="clearable"
    :label="label"
    :placeholder="placeholder"
    :hint="hint"
    :persistent-hint="persistent_hint"
    :disabled="disabled"
    :item-text="item_text"
    :item-value="item_value"
    :loading="loading"
    :readonly="readonly"
    :rules="rules"
    :multiple="multiple"
  >
    <!-- <template v-slot:selection="{ item, index }">
      <v-chip small v-if="index < 3">
        <span>{{ item[item_text] | formatAbbreviation(20)}}</span>
      </v-chip>
      <span
        v-if="index === 3"
        class="grey--text caption"
      >{{(items.length === selectedItem.length) ? '(Todos)' : ("(+" + (selectedItem.length - 3) + " outros)")}}</span>
    </template> -->
    <!-- // Selection incluido para quebrar a linha para palavras muito grandes -->
    <template v-slot:selection="data">
      <v-chip v-if="multiple" small>
        <span>{{ data.item[item_text] | formatAbbreviation(20)}}</span>
      </v-chip>
      <div v-else class="v-select__selection v-select__selection--comma break-all one-line">
        {{data.item[item_text]}}
      </div>
    </template>
    <!-- Inclui o botão de editar caso habilitadp -->
    <template v-slot:item="data" v-if="showEditItem">
      <v-list-tile-action v-if="multiple" >
        <v-checkbox :input-value="data.tile.props.value"></v-checkbox>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{data.item[item_text]}}</v-list-tile-title>
        <!-- // caso seja status e seja um status d econclusão, mostra pro usuário -->
        <v-list-tile-sub-title v-if="entity === 'task_status' && data.item.identifier == 3">Status de conclusão</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-avatar v-if="data.item[item_value] == value || multiple" @click="clickEdit(data.item)">
        <v-tooltip top>
          <v-btn :id="id+'_edit'" slot="activator" small flat color="grey lighten-4" class="mx-0">
            <v-icon color="orange">edit</v-icon>
          </v-btn>
          <span>Editar</span>
        </v-tooltip>
      </v-list-tile-avatar>
    </template>
    <!-- // incluido o form para não ficar prepreenchendo o campo de pesquisa -->
    <template v-slot:prepend-item>
      <!-- // @submit.prevent="" usado pois ao apertar enterno campo pesquisar estava atualizando a tela -->
      <v-form autocomplete="off" @submit.prevent="">
        <v-layout align-center>
          <v-flex grow>
            <v-list-tile ripple>
              <v-text-field :id="id+'_search'" :ref="id+'_search'" name="search" @keyup.native="keyupSearch" append-icon="search" label="Pesquisar" v-model="search" :loading="loading"></v-text-field>
            </v-list-tile>
          </v-flex>
          <v-flex shrink>
            <v-tooltip bottom>
              <v-btn slot="activator" icon @click="close()">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Fechar</span>                  
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-form>
      <!-- // Caso tenha onlyThisItems e for um campo d estatus ou categoria significa que é um campo na inlcusão ou ediçaõ de tarefas, e nesses campos não é possivel por enquanto, adicionar uma nova categoria ou status pois essas adições não forama dicionadas na area de trabalho -->
      <span v-if="(onlyThisItemsIsSet() && (entity === 'task_status' || entity === 'task_category'))">Para adicionar {{entity === 'task_status' ? ' um status ' : ' uma categoria '}} vá na edição ou criação de uma {{translate('table.task_board.title')[0]}}</span>
      <v-btn v-else-if="showAddItem" :id="id+'_add'" block outline @click="clickAdd()" color="primary">Adicionar</v-btn>
    </template>
    <!-- <template v-slot:append-item v-if="items.length < totalItems">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-btn v-else :id="id+'_show_more'" flat block @click="clickShowMore()" color="primary">Mostrar mais</v-btn>
    </template> -->
    <template v-slot:append-item v-if="onlyThisItemsIsSet() && !getValuesBd">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-btn v-else :id="id+'_get_values_bd'" flat block @click="clickGetValuesBd()" color="primary">Todos os itens</v-btn>
    </template>
    <template v-slot:append-item v-else-if="items.length < totalItems">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-btn v-else :id="id+'_show_more'" flat block @click="clickShowMore()" color="primary">Mostrar mais</v-btn>
    </template>

  </v-select>
</template>

<script>
  /* eslint-disable eqeqeq, no-unneeded-ternary */
  export default {
    name: 'PSelect',
    data () {
      // selectedItem: null,
      return {
        setKeyup: null,
        selectedId: null,
        search: '',
        items: [],
        totalItems: 0,
        loading: false,
        showSelect: true,
        // getValuesBd serve para sempre buscar os valores do banco, acontece quando o usuário possui registros selecionados no filtro mas quer usar outros registros sem ser os selecionados
        getValuesBd: false,
        showMore: 1
      }
    },
    props: {
      id: {
        default: 'id_field'
      },
      entity: {
        default: 'field_entity'
      },
      // implementado null, para quanod tiver algum rule de required e identificar que está
      value: {
        default: () => { return null }
      },
      // selectedItem representa o item selecionado para acrescentar quando ele não estiver na busca
      selectedItem: {
        default: null
      },
      // onlyThisItems usado para trazer os ids e buscar apenas aqueles ids
      onlyThisItems: {
        default: () => { return [] }
      },
      // Caso tenha vindo valores do componente mãe usa eles
      itemsProps: {
        default: null
      },
      label: {
        default: 'Items'
      },
      placeholder: {
        default: ''
      },
      hint: {
        default: ''
      },
      item_text: {
        default: 'id_text'
      },
      item_value: {
        default: 'id'
      },
      readonly: {
        default: false
      },
      companyId: {
        default: ''
      },
      // showAddItem propriedade criada para mostra o botão de adicionar
      showAddItem: {
        type: Boolean,
        default: false
      },
      // showEditItem propriedade criada para mostra o botão de editar no item selecionado
      showEditItem: {
        type: Boolean,
        default: false
      },
      disabled: {
        default: false
      },
      persistent_hint: {
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      clearable: {
        default: false
      },
      // type serve para quando vem o selecte_editable que tem que mandar o type para saber quais registros buscar
      type: {
        default: ''
      },
      filter: {},
      rules: {},
      index: {},
      where: {
        default: ''
      }
    },
    mounted () {
      // Caso tenha vindo valores do componente mãe usa eles
      if (Array.isArray(this.itemsProps)) {
        this.setItems(this.itemsProps)
      } else {
        // apensa inicializa para já vir com os valores do editedItem caso seja edição
        this.setItems(this.items)
      }
    },
    methods: {
      close () {
        this.$emit('close')
        // variavel showSelect recebe false e depois true para pdoer fechar o quadro de seleção quando o usuário aperta no x
        this.showSelect = false
        setTimeout(() => {
          this.showSelect = true
        }, 100)
      },
      clickAdd () {
        // verifica se a empresa do registro é diferente da empresa do usuário, caso seja, não deixa inserir, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if (this.companyId != '' && this.companyId != this.$auth.user().company_id) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possível incluir registros em tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        this.$emit('clickAdd')
        // Chama o close para fechar a lista de seleção
        this.close()
      },
      clickEdit (item = null) {
        // quando esta com múltipla seleção e o usuário clica para editar o item, está selecionando também devido o comportamento padrão do componente v-select, portanto é chamado o changeSelect dos valores antigos para desfazer o click e apenas editar
        if (this.multiple) {
          let beforeValues = JSON.parse(JSON.stringify(this.value))
          setTimeout(() => {
            this.changeSelect(beforeValues)
          }, 100)
        }
        // verifica se a empresa do registro é diferente da empresa do usuário, caso seja, não deixa editar, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if (this.companyId != '' && this.companyId != this.$auth.user().company_id) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possível editar registros em tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        this.$emit('clickEdit', item)
        // Chama o close para fechar a lista de seleção
        this.close()
      },
      keyupSearch () {
        // caso o usuario fique 1 segundo sem digitar e feita uma busca da pagina novamente
        clearTimeout(this.setKeyup)
        this.setKeyup = setTimeout(() => {
          this.showMore = 1
          this.getValues()
        }, 500)
      },
      setItems (items = this.items) {
        this.items = []
        // Começa incluindo todos os itens passados em parametro para a variavel this.items
        this.items = JSON.parse(JSON.stringify(items))
        // caso o this.selectedItem seja um array significa que está com mais de um valor selecionado, o que ocorre quando a seleção é mulitpla, sendo necessário incluir todos os registros
        if (Array.isArray(this.selectedItem)) {
          this.selectedItem.forEach(item => {
            if (item && item[this.item_value] > 0 && !items.some((val) => { return val[this.item_value] == item[this.item_value] })) {
              this.items.unshift(item)
            }
          })
        } else {
          // Verifica se existe algum item selecionado e se ele não está na lista de itens, pois se não tiver adiciona ele, necessário na tarefamodelo que no editar não carrega os dados ainda
          if (this.selectedItem && this.selectedItem[this.item_value] > 0 && !items.some((val) => { return val[this.item_value] == this.selectedItem[this.item_value] })) {
            this.items.unshift(this.selectedItem)
          }
        }
        // if (this.selectedItem) {
        //   if (this.multiple) {
        //     this.selectedItem.forEach(item => {
        //       if (item[this.item_value] > 0 && !this.items.some((val) => { return val[this.item_value] == item[this.item_value] })) {
        //         this.items.unshift(this.selectedItem)
        //       }
        //     });
        //   } else if (this.selectedItem[this.item_value] > 0 && !this.items.some((val) => { return val[this.item_value] == this.selectedItem[this.item_value] })) {
        //     this.items.unshift(this.selectedItem)
        //   }
        // }
      },
      getValues () {
        // So busca os valores quando não veio valor do componente mãe
        if (!Array.isArray(this.itemsProps) || this.getValuesBd) {
          this.loading = true
          let params = `?entity=${this.entity}&onlyThisItems=${(this.onlyThisItemsIsSet() && !this.getValuesBd) ? this.onlyThisItems : ''}&where=${this.where}&search=${this.search}&value=${this.value ? this.value : ''}&per_page=${this.showMore * 10}&type=${this.type}&company_id=${this.companyId}`
          this.$http.get(`api/get_select_values${params}`).then((res) => {
            this.setItems(res.body.data)
            this.totalItems = res.body.total
            this.loading = false
          }, err => {
            console.log(err)
            this.loading = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros, reporte o erro.', color: 'error', dialog: true})
          })
        } else {
          if (this.search == '') {
            this.setItems(this.itemsProps)
          } else {
            // faz a busca caso o usuário tenha digitado algo
            this.setItems(this.itemsProps.filter((val) => {
              const hasValue = val => val != null ? val : ''
              const search = hasValue(this.search).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
              const text = hasValue(val[this.item_text]).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
              // Filtra os registros da pesquisa ou os registros selecionados
              if (this.multiple) {
                return text.indexOf(search) > -1 || this.value.includes(val[this.item_value])
              } else {
                return text.indexOf(search) > -1 || this.value == val[this.item_value]
              }
            }))
          }
        }
      },
      changeSelect (val) {
        if (this.multiple) {
          let ids = val ? val : null
          let items = []
          ids.forEach(id => {
            items.push(this.items.find(item => item[this.item_value] === id))
          })
          this.$emit('change', ids, items)
          // precisa do input pois quando era null estava passando undefined no vmodel
          this.$emit('input', ids)
        } else {
          // coloca null pois quando usa o clearable estava vindo undefined e não estava sendo aceito nas rules
          let id = val ? val : null
          let item = this.items.find(item => item[this.item_value] === id)
          this.$emit('change', id, item)
          // precisa do input pois quando era null estava passando undefined no vmodel
          this.$emit('input', id)
        }
      },
      blurSelect () {
        if (this.multiple) {
          let ids = this.value ? this.value : null
          let items = []
          if (Array.isArray(ids)) {
            ids.forEach(id => {
              items.push(this.items.find(item => item[this.item_value] === id))
            })
          }
          this.$emit('blur', ids, items)
        } else {
          let id = this.value ? this.value : null
          let item = this.items.find(item => item[this.item_value] === id)
          this.$emit('blur', id, item)
        }
      },
      clickSelect () {
        this.search = ''
        // foca o campo de pesquisa quando abre a tela no pc
        if (!this.$vuetify.breakpoint.smAndDown) {
          setTimeout(() => {
            if (this.$refs[this.id + '_search']) this.$nextTick(() => this.$refs[this.id + '_search'].focus())
          }, 300)
        }
        this.$emit('click')
        this.getValues()
      },
      clickShowMore () {
        this.showMore++
        this.getValues()
      },
      clickGetValuesBd () {
        this.getValuesBd = true
        this.getValues()
      },
      // O only this items pode vir tanto com arrray como com integer, exemplo tarefa modelo ou equipe, portanto deve verificar qual tipo ele esta
      onlyThisItemsIsSet () {
        return Array.isArray(this.onlyThisItems) ? (this.onlyThisItems.length > 0) : this.onlyThisItems > 0
      }
    },
    watch: {
      // value (id) {
      //   this.setItems(this.items)
      //   this.selectedItem = id
      // },
      selectedItem (item) {
        // semrpe que altera o item selecionado monta novamente para ele sempre estar na seleção
        this.setItems(this.items)
      }
    },
    computed: {}
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PSelect.vue